import {
  FaArrowRight,
  FaCheckCircle,
  FaCarSide,
  FaShieldAlt,
  FaClock,
  FaHeadset,
  FaPhoneAlt,
} from "react-icons/fa";
import {
  taxis,
  stats,
  workProcess,
  testimonials,
} from "../data/content";
import { IMAGES, ABOUT_APP } from "../data/images";
import SectionTitle from "../components/common/SectionTitle";
import { TaxiCard } from "../components/common/Cards";
import StarRating from "../components/common/StarRating";
import Counter from "../components/common/Counter";
import CtaBanner from "../components/common/CtaBanner";
import { BOOKING_URL, PHONE_TEL } from "../data/config";
import "./home.css";

export default function Home() {
  return (
    <>
      {/* HERO */}
      <section
        className="hero"
        style={{ backgroundImage: `linear-gradient(rgba(10,10,10,.78),rgba(10,10,10,.62)), url(${IMAGES.heroTaxi})` }}
      >
        <div className="container hero-inner">
          <div className="hero-text fade-up">
            <span className="chip">🚕 Fast • Safe • Affordable</span>
            <h1>
              Your Reliable <span>Taxi</span> Partner for Every Journey
            </h1>
            <p>
              Book a ride in seconds and travel in comfort with Taxi24hrs.
              Professional drivers, modern vehicles and transparent pricing,
              available 24/7 across the city.
            </p>
            <div className="hero-btns">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                Book online Now <FaArrowRight />
              </a>
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn btn-outline">
                Get a Quotation
              </a>
              <a href={PHONE_TEL} className="btn btn-dark hero-call">
                <FaPhoneAlt /> Call Now
              </a>
            </div>
            <div className="hero-points">
              <span><FaCheckCircle /> Licensed Drivers</span>
              <span><FaCheckCircle /> 24/7 Availability</span>
              <span><FaCheckCircle /> Best Prices</span>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES STRIP */}
      <section className="section-sm feature-strip">
        <div className="container grid grid-4">
          {[
            { icon: <FaCarSide />, t: "Modern Fleet", d: "Clean, comfortable vehicles" },
            { icon: <FaShieldAlt />, t: "Safe Rides", d: "Verified, trained drivers" },
            { icon: <FaClock />, t: "Always On Time", d: "Punctual every trip" },
            { icon: <FaHeadset />, t: "24/7 Support", d: "We're here whenever you need" },
          ].map((f, i) => (
            <div className="fstrip-item" key={i}>
              <span className="fstrip-icon">{f.icon}</span>
              <div>
                <h4>{f.t}</h4>
                <p>{f.d}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ABOUT */}
      <section className="section">
        <div className="container about-grid">
          <div className="about-single">
            <img src={ABOUT_APP} alt="Taxi24hrs 24 hours customer support" />
          </div>
          <div className="about-content">
            <SectionTitle
              align="left"
              subtitle="About Taxi24hrs"
              title="We Make Every Ride <span>Safe & Comfortable</span>"
              text="For over a decade, Taxi24hrs has been the city's trusted taxi service, delivering safe, reliable and affordable journeys to thousands of happy customers every day."
            />
            <ul className="about-list">
              <li><FaCheckCircle /> Professional and experienced drivers</li>
              <li><FaCheckCircle /> Affordable and transparent pricing</li>
              <li><FaCheckCircle /> Comfortable and clean vehicles</li>
              <li><FaCheckCircle /> Fast and reliable transportation</li>
            </ul>
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              Book online Now <FaArrowRight />
            </a>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="section-sm stats-section">
        <div className="container stats-row">
          {stats.map((s, i) => (
            <div className="stat-item" key={i}>
              <div className="num">
                <Counter end={s.value} suffix={s.suffix} />
              </div>
              <div className="lbl">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* TAXIS */}
      <section className="section">
        <div className="container">
          <SectionTitle
            subtitle="Our Fleet"
            title="Choose Your <span>Perfect Ride</span>"
            text="A diverse fleet to match every need and budget — all maintained to the highest standards."
          />
          <div className="grid grid-3">
            {taxis.map((t) => (
              <TaxiCard key={t.id} taxi={t} />
            ))}
          </div>
        </div>
      </section>

      {/* WORK PROCESS */}
      <section className="section bg-dark2">
        <div className="container">
          <SectionTitle
            subtitle="How It Works"
            title="Book Your Taxi in <span>4 Easy Steps</span>"
          />
          <div className="grid grid-4 process-grid">
            {workProcess.map((p, i) => (
              <div className="process-card" key={i}>
                <span className="process-step">{p.step}</span>
                <h3>{p.title}</h3>
                <p>{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="section">
        <div className="container">
          <SectionTitle
            subtitle="Testimonials"
            title="What Our <span>Riders Say</span>"
          />
          <div className="grid grid-3">
            {testimonials.slice(0, 3).map((t, i) => (
              <div className="testi-card card" key={i}>
                <StarRating rating={t.rating} />
                <p className="testi-text">"{t.text}"</p>
                <div className="testi-author">
                  <div>
                    <h4>{t.name}</h4>
                    <span>{t.role}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBanner />
    </>
  );
}
